import React from "react";
import { useHistory } from "react-router-dom";
import { RequirementDetailsContent } from "../../../Requirements/components/RequirementsDetails/RequirementDetailsContent";
import { useRequirementsConfig } from "../../../Requirements/useRequirementsConfig";
import { WSPageToolbar } from "@wingspanhq/fe-component-library";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import {
  PAYERS_REQUIREMENTS_PATH,
  getPayerDetailsRequirementsUrl
} from "../../paths";
import { RequirementContextType } from "../../../Requirements/types";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces/api/requirement";
import { IPayerResponse } from "@wingspanhq/payments/dist/interfaces";

type RequirementsDetailsProps = {
  payer: IPayerResponse;
  requirement: IRequirementResponse;
};

export const RequirementsDetailsRoute: React.FC<RequirementsDetailsProps> = ({
  payer,
  requirement
}) => {
  const history = useHistory();

  const requirementConfig = useRequirementsConfig({
    requirements: [requirement],
    contextType: RequirementContextType.Payer
  });

  const clientInfo = wsName({
    user: {
      email: payer.user?.email as string,
      profile: payer.user?.profile
    },
    member: payer.member,
    payeeOwnedData: payer.payeeOwnedData
  });

  const title =
    requirementConfig.getRequirementName(requirement) || "Requirement";

  return (
    <>
      <WSPageToolbar
        actions={requirementConfig.getToolbarActions(requirement)}
        breadcrumbs={[
          {
            label: "Clients",
            onClick: () => {
              history.push(PAYERS_REQUIREMENTS_PATH);
            }
          },
          {
            label: clientInfo.getResolvedName(),
            onClick: () => {
              history.push(getPayerDetailsRequirementsUrl(payer.payerId));
            }
          },
          // {
          //   label: engagementName,
          //   onClick: () => {
          //     history.push(
          //       `${PAYERS_PATH}/${payer.payerId}/engagements/${engagementId}`
          //     );
          //   }
          // },
          {
            label: title
          }
        ]}
      />

      <RequirementDetailsContent
        {...requirementConfig}
        contextType={RequirementContextType.Payer}
        requirement={requirement}
      />
    </>
  );
};
